// Snobby: collapsible collection description (mobile only)
(function() {
  function init() {
    if (!document.body.classList.contains('template-collection')) return;
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    document.querySelectorAll('.text__content').forEach(function(el) {
      // Skip if already processed
      if (el.hasAttribute('data-collapsible')) return;
      // Only apply when content overflows ~5.5em = ~110px
      if (el.scrollHeight < 120) return;

      el.setAttribute('data-collapsible', 'true');

      var btn = document.createElement('button');
      btn.className = 'text__content-toggle';
      btn.type = 'button';
      btn.textContent = 'Ver más';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function() {
        var expanded = el.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Ver menos' : 'Ver más';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      el.insertAdjacentElement('afterend', btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-check on resize (rotate device, etc.)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
})();
